import {rehydrateCss, renderApp} from '../init'
import reducers from './reducers'

rehydrateCss()
const routes = require('./routes').default
renderApp(reducers, routes)
